import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'ldw-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.css'],
    standalone: false
})
export class ConfirmDialogComponent {
  dialogRef = inject<MatDialogRef<ConfirmDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  title!: string;
  message!: string;

  isCancelButtonDefault(): boolean {
    if (this.data == undefined || this.data.okIsDefault == undefined) {
      return true;
    }
    return !(this.data.okIsDefault == 'true');
  }
}
